import React from 'react';
import { ITopHeaderProps } from '../../types/topHeader';
import './topHeader.scss';

export const TopHeader: React.FC<ITopHeaderProps> = ({
  logoUrl,
  language,
  helpdeskLabel = 'Helpdesk',
  helpdeskUrl = 'https://support.taxi2airport.com',
  borderColor = '#F6C82F',
}) => {
  const classBase = 'custom-top-header';

  const topHeaderCustomStyles = {
    '--border-color': borderColor,
  } as React.CSSProperties;

  return (
    <header
      className={classBase}
      data-testid={classBase}
      style={topHeaderCustomStyles}
    >
      <div className="image-container">
        {logoUrl && <img alt="logo" className="logo" src={logoUrl} />}
      </div>
      <div className="language-helpdesk-container">
        <div className="helpdesk">
          <a className="link" href={helpdeskUrl} target="_blank" rel="noreferrer">
            {helpdeskLabel}
          </a>
        </div>
        <div className="language-wrapper">
          {language}
        </div>
      </div>
    </header>
  );
};
